export default __webpack_public_path__ + "static/media/eth.65549806.png";